import React, {useEffect, useState} from "react";

import {useDropzone} from 'react-dropzone';

import Container from "../Container";
import Text from "../../designSystem/Text";
import FileIcon from "../../designSystem/icons/File";

export interface CertificateContainerProps {
    setFile: (f: File | null) => void;
    titleNumber?: number;
}


const CertificateContainer = (props: CertificateContainerProps) => {

    const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
        maxFiles: 1,
        maxSize: 40000000,
        accept: {
            'image/png': ['.png'],
            'image/jpg': ['.jpg', '.jpeg'],
            'application/pdf': ['pdf'],
        }
    });
    const { setFile } = props;
    const [close, setClose] = useState<boolean>(false)

    const fileNames: string[] = acceptedFiles.map((f: File) => (
        `${f.name}`
    ))

    useEffect(() => {
        const file: File | null = acceptedFiles.length > 0 ? acceptedFiles[0] : null;
        setFile(file)
    },[acceptedFiles, setFile])

    return (
        <Container
            containerTitle={"Autorisation parentale"}
            titleNumber={props.titleNumber}
            close={close}
            setClose={() => setClose(!close)}
        >
            <div className={"flex flex-col gap-y-2"}>
                <Text>
                    Remplir et signer l’attestation fournie par la Fédération Française de Voile&nbsp;·&nbsp;
                    <a target={"_blank"} rel="noreferrer" href={"https://www.ffvoile.fr/ffv/web/services/licences/documents/autorisation_parentale_licence_directe.pdf"} download>
                        Télécharger
                    </a>
                </Text>
                <section className={"px-4 py-8 border border-dashed border-grey--200 flex justify-center cursor-pointer bg-white"}>
                    <div {...getRootProps({className: 'dropzone'})}>
                        <input {...getInputProps()} />
                        {(fileNames.length > 0) ? (
                            <div className={"flex gap-x-2 gap-y-2 items-center"}>
                                <span className={"w-6 h-6"}><FileIcon /></span>
                                <span  className={"text-black"}>{fileNames[0]}</span>
                            </div>
                            ) : (
                            <div className={"flex flex-col items-center text-grey--400"}>
                                <span className={"text-center"}>
                                    Glissez vos fichiers&nbsp;ou&nbsp;
                                    <span className={"text-blue"}>Sélectionner un fichier</span>
                                </span>
                                <span>.jpg, .png, .pdf - max 5Mo</span>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </Container>
    )
}

export default CertificateContainer;